export const useCreditCheck = () => {
  const CREDIT_CHECK_TIMEOUT_MS = 4000;
  const CREDIT_CHECK_DENY_CODE = 3;
  const { $api } = useNuxtApp();

  async function performCreditCheck(orderGuid?: string): Promise<boolean> {
    try {
      const timeoutPromise = new Promise<never>((_, reject) =>
        setTimeout(() => reject(new Error('timeout')), CREDIT_CHECK_TIMEOUT_MS),
      );

      const response = await Promise.race([
        $api.checkout.creditCheck(orderGuid),
        timeoutPromise,
      ]);

      if (response.Code === CREDIT_CHECK_DENY_CODE) {
        navigateTo('/shop/betalstatus?cc=deny', { external: true });
        return false;
      }

      return true;
    } catch {
      return true;
    }
  }

  return { performCreditCheck };
};
